import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IChat, MessageStatusEnum} from "@/types/IChat";

export enum TrenchesFeedOperationEnum {
  NEW,
  EDIT,
  DELETE,
  NONE,
  REPLY,
  REACT,
  PIN,
}

export enum TrenchesFeedStatusEnum {
  PENDING,
  DONE
}

export type OperationObject = {
  content: string;
  files: { url: string; contentType: string; }[];
  replyFeedMessageId: number;
  writerDisplayName?: string;
  emojiId?: number;
  taggedUsers?: {
    taggedUsers: {
      id: number;
      handle: string;
    }[];
  },
}

interface IChatAttr {
  operation: TrenchesFeedOperationEnum
  operationObj: OperationObject
  status: TrenchesFeedStatusEnum
  channelId?: number;
}

const initialState: IChatAttr = {
  operation: TrenchesFeedOperationEnum.NONE,
  status: TrenchesFeedStatusEnum.PENDING,
  operationObj: {
    content: "",
    files: [],
    replyFeedMessageId: -1,
    writerDisplayName: "",
    emojiId: -1,
    taggedUsers: {
      taggedUsers: []
    }
  },
  channelId: -1
};
export const TrenchesFeedOperationsSlice = createSlice({
  name: "trenches_feed_operations_slice",
  initialState,
  reducers: {
    setChannelId: (state, action: PayloadAction<number>) => {
      state.channelId = action.payload;
    },
    setOperation: (state, action: PayloadAction<IChatAttr>) => {
      state.operation = action.payload.operation;
      state.operationObj = action.payload.operationObj;
      state.status = action.payload.status;
    },
    resetOperation: (state) => {
      state.operation = TrenchesFeedOperationEnum.NONE
      state.status = TrenchesFeedStatusEnum.PENDING
      state.operationObj = {
        content: "",
        files: [],
        replyFeedMessageId: -1,
        writerDisplayName: "",
        emojiId: -1,
        taggedUsers: {
          taggedUsers: []
        }
      }
    }
  },
});

export const {
  setOperation,
  resetOperation,
  setChannelId
} = TrenchesFeedOperationsSlice.actions;

export default TrenchesFeedOperationsSlice.reducer;